import React from "react";
import {  PageHeader, TeamMember } from "../../components";
import ScrabbleGallery from "./directory/scrabble";

export default function Scrabble() {
  return (
    <div className="page-content">
      <PageHeader title="Scrabble " page="scrabble" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- contact -> */}
        <div className="content">
          {/* <!-- About Company --> */}
          {/* <!-- Our Awesome Services --> */}
          <div className="section-full bg-gray content-inner ">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center section-head mamber-dec">
                  <h3 className="h2">WELCOME TO SCRABBLE</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <div className="clear"></div>
                  <p class="font-weight-3 m-b30">
                    The Scrabble Section of the Lagos Country Club is a vibrant
                    community of word enthusiasts united by a shared passion for
                    intellectual competition and strategic thinking. As one of
                    the most active sections within the Club, it provides a
                    platform for members of all ages to engage in regular
                    scrabble games, tournaments, and social activities that
                    promote mental sharpness and camaraderie.
                  </p>
                  <p class="font-weight-3 m-b30">
                    With a tradition of excellence, the section hosts internal
                    ladder competitions, and contributes participants to
                    national scrabble events. Members benefit from a
                    well-structured environment that supports both casual play
                    and competitive growth, welcoming newcomers and experienced
                    players alike.
                  </p>

                  <p class="font-weight-3 m-b30">
                    The Scrabble Section also plays a role in fostering
                    friendships and networking across generations, and continues
                    to evolve with initiatives that combine recreation with
                    learning, community building, and healthy competition—all in
                    line with the Lagos Country Club’s overall vision of
                    balanced lifestyle and personal development.
                  </p>
                  {/* <a href="/#" className="site-button">Learn More</a> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- About Company END --> */}
          <ScrabbleGallery />
          {/* <!-- Team member --> */}
          <TeamMember
            name="MR ABIDEMI MURAINA-TAIWO"
            title="LCC CHAIRMAN SCRABBLE"
            img="./assets/images/members/LCC_CHAIRMAN_SCRABBLE.JPG"
          />
          {/* <!-- Team member --> */}
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
